import { StorageHandler, StorageOptions } from "../../types/storage";

/* global document, console */

export class BrowserStorageHandler implements StorageHandler {
  async get(key: string): Promise<string | null> {
    try {
      const cookies = document.cookie.split(";").reduce((acc, cookie) => {
        const [key, value] = cookie.trim().split("=");
        acc[key] = value;
        return acc;
      }, {});

      return cookies[key] || null;
    } catch (error) {
      console.error("Error getting browser cookie:", error);
      return null;
    }
  }

  async set(
    key: string,
    value: string,
    options?: StorageOptions,
  ): Promise<void> {
    try {
      let cookie = `${key}=${value}`;

      if (options) {
        for (const [optionKey, optionValue] of Object.entries(options)) {
          cookie += `;${optionKey}=${optionValue}`;
        }
      }

      document.cookie = cookie;
    } catch (error) {
      console.error("Error setting browser cookie:", error);
      throw error;
    }
  }

  async remove(key: string): Promise<void> {
    try {
      document.cookie = `${key}=;path=/`;
    } catch (error) {
      console.error("Error removing browser cookie:", error);
      throw error;
    }
  }
}
